// extracted by mini-css-extract-plugin
module.exports = {"root":"root___2oxqm"};